export default __webpack_public_path__ + "static/media/Alert.77677ccc.svg";